const jobsAltTextI18nEn = {
  'altTextRepairerImage': 'Sustainable fashion jobs - fashion tech',
};

export default jobsAltTextI18nEn;
